/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Notification } from './Notification';
import {
    NotificationFromJSON,
    NotificationFromJSONTyped,
    NotificationToJSON,
    NotificationToJSONTyped,
} from './Notification';

/**
 * 
 * @export
 * @interface PaginatedNotificationList
 */
export interface PaginatedNotificationList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedNotificationList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedNotificationList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof PaginatedNotificationList
     */
    results: Array<Notification>;
}

/**
 * Check if a given object implements the PaginatedNotificationList interface.
 */
export function instanceOfPaginatedNotificationList(value: object): value is PaginatedNotificationList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedNotificationListFromJSON(json: any): PaginatedNotificationList {
    return PaginatedNotificationListFromJSONTyped(json, false);
}

export function PaginatedNotificationListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedNotificationList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(NotificationFromJSON)),
    };
}

  export function PaginatedNotificationListToJSON(json: any): PaginatedNotificationList {
      return PaginatedNotificationListToJSONTyped(json, false);
  }

  export function PaginatedNotificationListToJSONTyped(value?: PaginatedNotificationList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(NotificationToJSON)),
    };
}

